var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinterRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.834 9H25V5a1 1 0 00-1-1H8a1 1 0 00-1 1v4H5.166C3.42 9 2 10.346 2 12v10a1 1 0 001 1h4v4a1 1 0 001 1h16a1 1 0 001-1v-4h4a1 1 0 001-1V12c0-1.654-1.42-3-3.166-3zM9 6h14v3H9V6zm14 20H9v-6h14v6zm5-5h-3v-2a1 1 0 00-1-1H8a1 1 0 00-1 1v2H4v-9c0-.551.524-1 1.166-1h21.668c.642 0 1.166.449 1.166 1v9zm-3-6.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"
  })));
}
export default SvgPrinterRegular;